export default __webpack_public_path__ + "files/6aa935f8b8f9ea243469fe841b5a1265.jpg";